import { Box, Typography } from "@mui/material";

interface LogoProps {
  variant: "h3" | "h5";
  onClick?: () => void;
  sx?: any;
}

const Logo = ({ variant, onClick = () => {}, sx }: LogoProps) => (
  <Typography variant={variant} sx={{ userSelect: "none", fontWeight: 400, ...sx }} onClick={onClick}>
    <Box sx={{ display: "inline", color: "primary.main" }}>
      THO<span style={{ fontWeight: 600 }}>M</span>
    </Box>
    <span style={{ fontWeight: 400, color: "#434346" }}>erch</span>
  </Typography>
);

export default Logo;
